/*
 * PA Naturals — Shopping Buddy controller.
 * Isolated: only creates/edits elements it owns (.pa-buddy). Never calls
 * preventDefault, never posts to the cart, never changes cart contents.
 * Reads the cart with GET /cart.js only, after Horizon's own cart:update event.
 */
(function () {
  'use strict';

  if (window.PABuddyController) {
    window.PABuddyController.boot();
    return;
  }

  var POSE_LABELS = {
    idle: 'IDLE', walk: 'WALK', run: 'RUN', inspect: 'INSPECT', point: 'POINT', pout: 'POUT',
    curious: 'CURIOUS', excited: 'EXCITED', celebrate: 'CELEBRATE', basket_full: 'BASKET FULL'
  };
  var HOVER_LINES = ['Shall we try this one?', "Let's have a look!", 'Ooh, this looks interesting!'];
  var ADDED_LINE = 'Yay! Added to your basket!';
  var SOLD_OUT_LINE = 'Oh no\u2026 this one\u2019s sold out.';
  // Body poses that have no dedicated art borrow a body and add a face close-up.
  var BODY_FALLBACK = { pout: 'idle', excited: 'thumbs', idle_blink: 'idle' };
  var DEFAULT_FACE = { pout: 'angry', excited: 'excited' };
  var SELECT_KEY = 'pa-buddy:selected';
  var CHECKOUT_SELECTOR = [
    '[name="checkout"]', 'a[href*="/checkout"]', 'button[form][name="checkout"]', '.cart__checkout-button',
    'shopify-accelerated-checkout', 'shopify-accelerated-checkout-cart'
  ].join(',');
  // Content she must never sit on top of (controls, prices, product media, forms, navigation).
  var AVOID_SELECTOR = [
    'header-component', 'nav', 'product-form-component', 'variant-picker', 'quantity-selector-component',
    'add-to-cart-component', 'product-price', '.price', 'media-gallery', 'sticky-add-to-cart',
    'cart-items-component', 'product-card', 'button', 'input', 'select', 'textarea', '[role="button"]',
    'shopify-accelerated-checkout', 'shopify-accelerated-checkout-cart', '.shopify-payment-button',
    'main p', 'main h1', 'main h2', 'main h3', 'main h4', 'main li', 'main a[href]', 'main label'
  ].join(',');
  var EMPTY_LINE = 'Your basket is empty \u2014 have a look around!';
  var CARD_CONTROL_SELECTOR = 'button, form, select, input, quick-add-component, product-form-component, add-to-cart-component';

  function store(op, k, v) {
    try {
      if (op === 'get') return window.sessionStorage.getItem(k);
      if (op === 'set') window.sessionStorage.setItem(k, v);
      if (op === 'del') window.sessionStorage.removeItem(k);
    } catch (e) { /* storage unavailable */ }
    return null;
  }
  var DEBUG = (function () { try { return window.localStorage.getItem('pa-buddy-debug') === '1'; } catch (e) { return false; } })();
  function log() { if (DEBUG) console.debug.apply(console, ['[PA Buddy]'].concat([].slice.call(arguments))); }
  function now() { return performance.now(); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function overlap(a, b) {
    var w = Math.min(a.r, b.r) - Math.max(a.l, b.l);
    var h = Math.min(a.b, b.b) - Math.max(a.t, b.t);
    return w > 0 && h > 0 ? w * h : 0;
  }

  function PABuddy(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId || 'pa-buddy';
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-pa-buddy-config]').textContent); } catch (e) { cfg = {}; }
    this.cfg = Object.assign({ activity: 'full', showMobile: true, corner: 'right', bubbles: true, basketFullAt: 2, pageType: '', productId: null, assets: {} }, cfg);
    this.cfg.assets = this.cfg.assets || {};
    this.ac = new AbortController();
    this.named = new Map();
    this.suppress = new Set();
    this.mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mqTouch = window.matchMedia('(hover: none), (pointer: coarse)');
    this.x = this.y = this.tx = this.ty = 0;
    this.raf = 0; this.last = 0; this.moving = false; this.running = false; this.frameT = 0;
    this.atHome = true;
    this.reaction = null;
    this.blinking = false;
    this.hoverCard = null; this.hoverId = null; this.hoverVia = null;
    this.lastCardId = null; this.lastLeave = 0;
    this.cart = { count: 0, lines: 0 };
    this.cartSeq = 0;
    this.pendingCelebrate = 0;
    this.bubbleCount = 0; this.lastBubble = -1e9;
    this.pointed = new Set();
    this.tappedId = null;
    this.shownKey = null; this.metaText = '';
    this.destroyed = false;
    this.state = { lastEvent: null, celebrations: 0, ignoredErrors: 0 };

    this.build();
    this.applyEnv();
    this.goHome(true);
    this.bind();
    this.refreshCart();
    this.checkArrival();
    this.blinkLoop();
    this.preloadLater();
    var self = this;
    requestAnimationFrame(function () { if (!self.destroyed) { self.root.classList.add('is-visible'); self.render(); } });
    log('ready', this.cfg);
  }

  PABuddy.prototype.build = function () {
    var r = this.root;
    var body = document.createElement('div'); body.className = 'pa-buddy__body';
    var shadow = document.createElement('div'); shadow.className = 'pa-buddy__shadow';
    var img = document.createElement('img'); img.className = 'pa-buddy__img'; img.alt = ''; img.decoding = 'async'; img.draggable = false; img.hidden = true;
    var st = document.createElement('div'); st.className = 'pa-buddy__standin';
    var sp = document.createElement('span'); sp.className = 'pa-buddy__standin-pose';
    var sm = document.createElement('span'); sm.className = 'pa-buddy__standin-meta'; sm.textContent = 'TEMP STAND-IN';
    var sf = document.createElement('span'); sf.className = 'pa-buddy__standin-meta';
    st.append(sp, sm, sf);
    body.append(shadow, img, st);
    var bubble = document.createElement('div'); bubble.className = 'pa-buddy__bubble';
    var face = document.createElement('img'); face.className = 'pa-buddy__face'; face.alt = ''; face.decoding = 'async'; face.draggable = false;
    r.append(bubble, body, face);
    r.setAttribute('aria-hidden', 'true');
    this.els = { body: body, img: img, standin: st, pose: sp, meta: sm, facing: sf, bubble: bubble, face: face };
    // Escape the footer section so position:fixed is relative to the viewport.
    if (r.parentNode !== document.body) document.body.appendChild(r);
  };

  PABuddy.prototype.applyEnv = function () {
    this.reduced = this.mqReduce.matches;
    this.mobile = this.mqTouch.matches || window.innerWidth < 750;
    this.root.classList.toggle('is-mobile', this.mobile);
    this.W = this.mobile ? 76 : 148;
    this.H = this.mobile ? 86 : 168;
    var pt = String(this.cfg.pageType || '');
    var tooSmall = window.innerWidth < 320 || window.innerHeight < 460;
    var blockedPage = pt.indexOf('customers/') === 0 || pt === 'password' || (this.mobile && pt === 'cart');
    this.setSuppressed('screen', tooSmall || blockedPage || (this.mobile && !this.cfg.showMobile));
    var mode = this.cfg.activity;
    this.canFollow = mode === 'full' && !this.mobile && !this.reduced;
    this.canTravel = (mode === 'full' || mode === 'calm') && !this.mobile && !this.reduced;
    this.reactsToProducts = mode !== 'minimal';
  };

  PABuddy.prototype.bind = function () {
    var self = this;
    var sig = this.ac.signal;
    var passive = { signal: sig, passive: true };
    document.addEventListener('pointermove', function (e) { self.onPointerMove(e); }, passive);
    document.addEventListener('pointerover', function (e) { self.onPointerOver(e); }, passive);
    document.addEventListener('pointerout', function (e) { self.onPointerOut(e); }, passive);
    document.addEventListener('pointerdown', function (e) { self.onPointerDown(e); }, passive);
    document.addEventListener('focusin', function (e) { self.onFocusIn(e); }, { signal: sig });
    document.addEventListener('focusout', function (e) { self.onFocusOut(e); }, { signal: sig });
    document.addEventListener('click', function (e) { self.onClick(e); }, { signal: sig, capture: true, passive: true });
    document.addEventListener('cart:update', function (e) { self.onCartUpdate(e); }, { signal: sig });
    document.addEventListener('cart:error', function () { self.state.ignoredErrors++; self.state.lastEvent = 'cart:error'; log('cart:error – no celebration'); }, { signal: sig });
    window.addEventListener('scroll', function () { self.onScroll(); }, passive);
    window.addEventListener('resize', function () { self.onResize(); }, passive);
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.setSuppressed('checkout', false); }, { signal: sig });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { cancelAnimationFrame(self.raf); self.raf = 0; self.last = 0; }
      else self.startLoop();
    }, { signal: sig });
    this.mqReduce.addEventListener('change', function () { self.onResize(); }, { signal: sig });
    this.mqTouch.addEventListener('change', function () { self.onResize(); }, { signal: sig });
    this.mo = new MutationObserver(function () { self.syncDialogs(); });
    this.mo.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    this.syncDialogs();
  };

  /* ---------- timers ---------- */
  PABuddy.prototype.setNamed = function (name, ms, fn) {
    this.clearNamed(name);
    var self = this;
    var id = setTimeout(function () { self.named.delete(name); if (!self.destroyed) fn(); }, ms);
    this.named.set(name, id);
  };
  PABuddy.prototype.clearNamed = function (name) {
    if (this.named.has(name)) { clearTimeout(this.named.get(name)); this.named.delete(name); }
  };

  /* ---------- visibility ---------- */
  PABuddy.prototype.setSuppressed = function (reason, on) {
    if (on) this.suppress.add(reason); else this.suppress.delete(reason);
    var hidden = this.suppress.size > 0;
    this.root.classList.toggle('is-suppressed', hidden);
    if (hidden) this.hideBubble();
  };
  PABuddy.prototype.isSuppressed = function () { return this.suppress.size > 0; };

  PABuddy.prototype.syncDialogs = function () {
    var drawer = document.querySelector('cart-drawer-component dialog');
    var drawerOpen = !!(drawer && drawer.open);
    var anyOpen = !!document.querySelector('dialog[open]');
    var wasDialog = this.suppress.has('dialog');
    this.drawerOpen = drawerOpen;
    if (drawerOpen && !this.drawerWasOpen) {
      this.drawerWasOpen = true;
      // A celebration that started just before the drawer covered her is replayed when it closes.
      if (now() - (this.lastCelebrateAt || -1e9) < 2500) this.pendingCelebrate = now();
    }
    this.setSuppressed('dialog', anyOpen);
    if (wasDialog && !anyOpen) this.onDialogsClosed();
  };
  PABuddy.prototype.onDialogsClosed = function () {
    var self = this;
    var wasDrawer = this.drawerWasOpen;
    this.drawerWasOpen = false;
    this._avoid = null;
    if (this.pendingCelebrate && now() - this.pendingCelebrate < 20000) {
      this.pendingCelebrate = 0; this.pendingCartChange = null;
      this.setNamed('pendingCelebrate', 250, function () { self.playCelebration(); });
    } else if (this.pendingCartChange && now() - this.pendingCartChange.t < 20000) {
      var pc = this.pendingCartChange; this.pendingCelebrate = 0; this.pendingCartChange = null;
      this.setNamed('pendingCelebrate', 250, function () { self.playCartChange(pc.dir, pc.count); });
    } else {
      this.pendingCelebrate = 0; this.pendingCartChange = null;
      if (wasDrawer && this.cart.count > 0 && now() - (this.lastDrawerAck || -1e9) > 30000 && this.reactsToProducts) {
        this.lastDrawerAck = now();
        this.setNamed('pendingCelebrate', 250, function () { self.react('thumbs', 1200, null, 'happy'); });
      }
    }
    this.refreshHome();
  };

  /* ---------- geometry ---------- */
  PABuddy.prototype.minTop = function () {
    var header = document.querySelector('header-component') || document.querySelector('.header');
    if (header) {
      var r = header.getBoundingClientRect();
      if (r.height > 0 && r.bottom > 0 && r.top <= 1) return r.bottom + 6;
    }
    return 8;
  };
  PABuddy.prototype.clampPos = function (x, y) {
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var vh = window.innerHeight;
    var minY = Math.min(this.minTop(), vh - this.H - 8);
    return { x: clamp(x, 8, vw - this.W - 8), y: clamp(y, minY, vh - this.H - 8) };
  };
  PABuddy.prototype.avoidRects = function () {
    var t = now();
    if (this._avoid && t - this._avoidT < 150) return this._avoid;
    var vw = document.documentElement.clientWidth || window.innerWidth, vh = window.innerHeight;
    var out = [], els = document.querySelectorAll(AVOID_SELECTOR);
    for (var i = 0; i < els.length && out.length < 500; i++) {
      var el = els[i];
      if (this.root.contains(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 2 || r.height < 2 || r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) continue;
      if (r.width > vw * 0.85 && r.height > 120) continue; // page-wide wrappers; their real content is checked individually
      out.push({ l: r.left, t: r.top, r: r.right, b: r.bottom });
    }
    this._avoid = out; this._avoidT = t;
    return out;
  };
  // The visible character occupies roughly the middle of her frame; collisions use that body box.
  PABuddy.prototype.bodyBox = function (x, y) {
    var vw = document.documentElement.clientWidth || window.innerWidth, vh = window.innerHeight;
    return { l: Math.max(0, x + this.W * 0.27), r: Math.min(vw, x + this.W * 0.73), t: Math.max(0, y + this.H * 0.16), b: Math.min(vh, y + this.H) };
  };
  PABuddy.prototype.coverAt = function (x, y) {
    var box = this.bodyBox(x, y), rects = this.avoidRects(), c = 0;
    for (var i = 0; i < rects.length; i++) c += overlap(box, rects[i]);
    return c / (this.W * 0.46 * this.H * 0.84);
  };
  PABuddy.prototype.homeCandidates = function () {
    var vw = document.documentElement.clientWidth || window.innerWidth, vh = window.innerHeight;
    var W = this.W, H = this.H, m = this.mobile ? 10 : 16;
    var side = this.cfg.corner === 'left' ? 'left' : 'right', other = side === 'left' ? 'right' : 'left';
    var minY = this.minTop();
    var ys = [vh - H - m, Math.max(minY, Math.round(vh * 0.55 - H / 2))];
    var out = [];
    [side, other].forEach(function (s) {
      ys.forEach(function (y) {
        [1, 0.62, 0.5].forEach(function (f) {
          var x = s === 'right' ? (f === 1 ? vw - W - m : vw - W * f) : (f === 1 ? m : -W * (1 - f));
          out.push({ x: x, y: y, peek: f === 1 ? null : s });
        });
      });
    });
    return out;
  };
  // Picks a resting spot that does not cover controls, prices, product media or navigation.
  // Keeps the current spot while it stays clear (no flicker); hides her if nowhere is clear.
  PABuddy.prototype.homePos = function () {
    var c = this.homeCandidates(), i, cur = this.homeIdx;
    if (cur != null && c[cur] && this.coverAt(c[cur].x, c[cur].y) < 0.03) return Object.assign({ crowded: false }, c[cur]);
    var best = -1, bestCover = Infinity;
    for (i = 0; i < c.length; i++) {
      var cv = this.coverAt(c[i].x, c[i].y);
      if (cv < 0.03) { best = i; bestCover = cv; break; }
      if (cv < bestCover) { bestCover = cv; best = i; }
    }
    this.homeIdx = best;
    return Object.assign({ crowded: bestCover > 0.2 }, c[best]);
  };
  PABuddy.prototype.followTarget = function (px, py) {
    var W = this.W, H = this.H, off = 40;
    var cands = [{ x: px + off, y: py + 14 }, { x: px - off - W, y: py + 14 }, { x: px + off, y: py - H - 14 }, { x: px - off - W, y: py - H - 14 }];
    var best = null, bc = Infinity;
    for (var i = 0; i < cands.length; i++) {
      var p = this.clampPos(cands[i].x, cands[i].y);
      if (px > p.x + W * 0.2 && px < p.x + W * 0.8 && py > p.y && py < p.y + H) continue; // never under the pointer
      var cv = this.coverAt(p.x, p.y);
      if (cv < 0.02) return p;
      if (cv < bc) { bc = cv; best = p; }
    }
    return bc <= 0.12 ? best : null; // nowhere clear near the pointer: stay put
  };
  PABuddy.prototype.bestSpotNear = function (card) {
    var r = card.getBoundingClientRect();
    var W = this.W, H = this.H, g = 10;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var cands = [
      { x: r.right + g, y: r.bottom - H }, { x: r.right + g, y: r.top },
      { x: r.left - g - W, y: r.bottom - H }, { x: r.left - g - W, y: r.top },
      { x: r.left + r.width / 2 - W / 2, y: r.bottom + g }
    ];
    var cards = [].slice.call(document.querySelectorAll('product-card')).map(function (c) {
      var b = c.getBoundingClientRect(); return { l: b.left, t: b.top, r: b.right, b: b.bottom };
    }).filter(function (b) { return b.b > 0 && b.t < window.innerHeight; });
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var best = null, bestDist = Infinity, self = this;
    cands.forEach(function (c) {
      var p = self.clampPos(c.x, c.y);
      var box = { l: p.x, t: p.y, r: p.x + W, b: p.y + H };
      var cover = 0;
      cards.forEach(function (b) { cover += overlap(box, b); });
      if (cover > W * H * 0.08) return; // would hide product content
      var dist = Math.hypot(p.x + W / 2 - cx, p.y + H / 2 - cy);
      if (dist < bestDist) { bestDist = dist; best = p; }
    });
    if (best) { best.peek = null; return best; }
    // Dense grid: peek in from the nearest viewport edge, level with the card.
    var side = cx > vw / 2 ? 'right' : 'left';
    var y = this.clampPos(0, r.top + r.height / 2 - H / 2).y;
    // Peek only as far as the page margin allows, so product images stay uncovered.
    var pick = null, pc = Infinity, fr = [0.75, 0.62, 0.5];
    for (var k = 0; k < fr.length; k++) {
      var px = side === 'right' ? vw - W * fr[k] : -W * (1 - fr[k]);
      var cv = this.coverAt(px, y);
      if (cv < 0.03) { pick = px; break; }
      if (cv < pc) { pc = cv; pick = px; }
    }
    return { x: pick, y: y, peek: side };
  };

  /* ---------- movement ---------- */
  PABuddy.prototype.setTarget = function (x, y, home, peek) {
    this.tx = x; this.ty = y; this.peek = peek || null;
    this.atHome = !!home;
    if (Math.abs(x - this.x) > 4) this.facing = x > this.x ? 'right' : 'left';
    this.startLoop();
  };
  PABuddy.prototype.startLoop = function () {
    if (this.raf || this.destroyed || document.hidden) return;
    if (Math.hypot(this.tx - this.x, this.ty - this.y) < 0.75) return;
    var self = this;
    this.raf = requestAnimationFrame(function (t) { self.tick(t); });
  };
  PABuddy.prototype.tick = function (t) {
    this.raf = 0;
    var dt = this.last ? Math.min(3, (t - this.last) / 16.667) : 1;
    this.last = t;
    var dx = this.tx - this.x, dy = this.ty - this.y, d = Math.hypot(dx, dy);
    if (d < 0.75) {
      this.x = this.tx; this.y = this.ty; this.last = 0;
      var was = this.moving; this.moving = false; this.running = false;
      if (was) this.onArrive();
      this.render();
      return;
    }
    var ease = 1 - Math.pow(1 - 0.085, dt);
    var maxStep = (d > 260 ? 15 : 8) * dt;
    var step = Math.min(d * ease + 0.4 * dt, maxStep, d);
    this.x += (dx / d) * step; this.y += (dy / d) * step;
    this.moving = true; this.running = d > 260; this.frameT = t;
    this.render();
    var self = this;
    this.raf = requestAnimationFrame(function (tt) { self.tick(tt); });
  };
  PABuddy.prototype.onArrive = function () {
    if (this.hoverCard) this.faceTowards(this.hoverCard);
    else if (this.atHome) this.facing = this.inwardFacing();
  };
  PABuddy.prototype.goHome = function (instant) {
    var h = this.homePos();
    this.setSuppressed('crowded', h.crowded);
    if (instant || !this.canTravel) {
      cancelAnimationFrame(this.raf); this.raf = 0; this.last = 0;
      this.x = this.tx = h.x; this.y = this.ty = h.y; this.moving = false; this.atHome = true; this.peek = h.peek;
      this.facing = this.inwardFacing();
      this.render();
      return;
    }
    this.setTarget(h.x, h.y, true, h.peek);
  };
  PABuddy.prototype.inwardFacing = function () {
    var vw = document.documentElement.clientWidth || window.innerWidth;
    return this.tx + this.W / 2 > vw / 2 ? 'left' : 'right';
  };
  PABuddy.prototype.refreshHome = function () {
    if (!this.atHome || this.hoverCard || this.destroyed) return;
    var h = this.homePos();
    this.setSuppressed('crowded', h.crowded);
    if (Math.abs(h.y - this.ty) > 2 || Math.abs(h.x - this.tx) > 2) {
      if (this.canTravel) this.setTarget(h.x, h.y, true, h.peek); else this.goHome(true);
    }
  };
  PABuddy.prototype.faceTowards = function (el) {
    var r = el.getBoundingClientRect();
    this.facing = (r.left + r.width / 2) > (this.x + this.W / 2) ? 'right' : 'left';
    this.render();
  };
  PABuddy.prototype.scheduleReturnHome = function () {
    var self = this;
    this.setNamed('home', 6500, function () { if (!self.hoverCard) self.goHome(); });
  };

  /* ---------- rendering ---------- */
  PABuddy.prototype.poseKey = function () {
    if (this.reaction && this.reaction.until > now()) return this.reaction.pose;
    if (this.moving) {
      var n = 1 + (Math.floor(this.frameT / (this.running ? 90 : 130)) % 4);
      return (this.running ? 'run_' : 'walk_') + n;
    }
    if (this.hoverCard) return 'inspect';
    if (this.cart.lines >= this.cfg.basketFullAt) return 'basket_full';
    if (this.cfg.pageType === 'product' && this.cfg.assets.hold) return 'hold';
    return this.blinking ? 'idle_blink' : 'idle';
  };
  PABuddy.prototype.assetFor = function (key) {
    var a = this.cfg.assets;
    if (a[key]) return a[key];
    if (BODY_FALLBACK[key] && a[BODY_FALLBACK[key]]) return a[BODY_FALLBACK[key]];
    if (/^walk_/.test(key)) return a.walk_1 || null;
    if (/^run_/.test(key)) return a.run_1 || a.walk_1 || null;
    return null;
  };
  PABuddy.prototype.render = function () {
    var r = this.root;
    r.style.transform = 'translate3d(' + Math.round(this.x) + 'px,' + Math.round(this.y) + 'px,0)';
    r.classList.toggle('is-facing-right', this.facing === 'right');
    r.classList.toggle('bubble-left', this.x + this.W / 2 < (window.innerWidth / 2));
    r.classList.toggle('is-peek-left', this.peek === 'left');
    r.classList.toggle('is-peek-right', this.peek === 'right');
    this.updateGhost();
    var key = this.poseKey();
    r.classList.toggle('is-breathing', !this.reduced && !this.mobile && !this.moving && /^(idle|basket_full|hold)/.test(key));
    r.classList.toggle('is-moving', this.moving && !this.reduced);
    r.dataset.pose = key;
    if (key !== this.shownKey) {
      this.shownKey = key;
      var src = this.assetFor(key);
      if (src) {
        if (this.els.img.getAttribute('src') !== src) this.els.img.src = src;
        this.els.img.hidden = false; this.els.standin.hidden = true;
      } else {
        this.els.img.hidden = true; this.els.standin.hidden = false;
        var base = key === 'idle_blink' ? 'idle' : key.replace(/_\d$/, '');
        this.els.pose.textContent = 'POSE: ' + (POSE_LABELS[base] || base.toUpperCase());
        this.els.meta.textContent = 'TEMP STAND-IN' + (key === 'idle_blink' ? ' · blink' : (/_\d$/.test(key) ? ' · ' + key.slice(-1) + '/4' : ''));
      }
    }
    var meta = (this.facing === 'right' ? 'faces →' : '← faces') + ' · basket ' + this.cart.count;
    if (meta !== this.metaText) { this.metaText = meta; this.els.facing.textContent = meta; }
  };
  PABuddy.prototype.updateGhost = function () {
    var p = this.ptr;
    var on = !!p && p.x > this.x - 16 && p.x < this.x + this.W + 16 && p.y > this.y - 16 && p.y < this.y + this.H + 16;
    if (on !== this.ghost) { this.ghost = on; this.root.classList.toggle('is-ghost', on); }
  };
  PABuddy.prototype.react = function (pose, ms, then, face) {
    var self = this;
    this.reaction = { pose: pose, until: now() + ms };
    var f = face || DEFAULT_FACE[pose];
    if (f) this.showFace(f, ms); else if (!then) this.hideFace();
    this.setNamed('reaction', ms, function () { self.reaction = null; if (then) then(); else self.render(); });
    this.render();
  };
  PABuddy.prototype.say = function (text, ms, force) {
    if (!this.cfg.bubbles || this.isSuppressed()) return;
    if (!force && (now() - this.lastBubble < 20000 || this.bubbleCount >= 4)) return;
    var b = this.els.bubble, self = this;
    b.textContent = text;
    b.classList.remove('is-alt');
    b.classList.add('is-shown');
    if (!this.placeBubble()) { this.hideBubble(); return; }
    this.lastBubble = now();
    if (!force) this.bubbleCount++;
    this.setNamed('bubble', ms, function () { self.hideBubble(); });
  };
  // Keeps the bubble on screen and off important content; returns false if there is no room.
  PABuddy.prototype.placeBubble = function () {
    var b = this.els.bubble, vw = document.documentElement.clientWidth || window.innerWidth;
    var rects = this.avoidRects(), minY = this.minTop() - 6, self = this;
    var bad = function () {
      var r = b.getBoundingClientRect();
      if (r.left < 4 || r.right > vw - 4 || r.top < minY) return true;
      var c = 0, area = Math.max(1, r.width * r.height), box = { l: r.left, t: r.top, r: r.right, b: r.bottom };
      for (var i = 0; i < rects.length; i++) c += overlap(box, rects[i]);
      return c / area > 0.35;
    };
    if (!bad()) return true;
    b.classList.add('is-alt');
    if (!bad()) return true;
    b.classList.remove('is-alt');
    return false;
  };
  PABuddy.prototype.showFace = function (name, ms) {
    var src = this.cfg.assets['face_' + name];
    if (!src || this.isSuppressed()) return;
    var el = this.els.face, self = this;
    if (el.getAttribute('src') !== src) el.src = src;
    el.classList.add('is-shown');
    this.root.dataset.face = name;
    this.setNamed('face', ms, function () { self.hideFace(); });
  };
  PABuddy.prototype.hideFace = function () {
    if (!this.els) return;
    this.els.face.classList.remove('is-shown');
    delete this.root.dataset.face;
  };
  PABuddy.prototype.hideBubble = function () {
    if (this.els) this.els.bubble.classList.remove('is-shown');
  };
  PABuddy.prototype.blinkLoop = function () {
    var self = this;
    this.setNamed('blink', 2800 + Math.random() * 3200, function () {
      if (!self.dreamyDone && self.atHome && !self.hoverCard && !self.reaction && !self.moving && now() - (self.lastActivity || 0) > 25000) {
        self.dreamyDone = true;
        self.react('idle', 2600, null, 'staring');
      } else if (!self.reduced && !self.moving && !self.reaction && self.cfg.assets.idle_blink) {
        self.blinking = true; self.render();
        self.setNamed('blinkEnd', 150, function () { self.blinking = false; self.render(); });
      }
      self.refreshHome();
      self.blinkLoop();
    });
  };
  PABuddy.prototype.preloadLater = function () {
    var urls = Object.keys(this.cfg.assets).map(function (k) { return this.cfg.assets[k]; }, this).filter(Boolean);
    if (!urls.length) return;
    var go = function () { urls.forEach(function (u) { var i = new Image(); i.decoding = 'async'; i.src = u; }); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 1500);
  };

  /* ---------- pointer / product interactions ---------- */
  PABuddy.prototype.onPointerMove = function (e) {
    if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    var px = e.clientX, py = e.clientY;
    this.ptr = { x: px, y: py };
    this.lastActivity = now();
    this.updateGhost();
    if (!this.canFollow || this.hoverCard || this.isSuppressed()) return;
    this.scheduleReturnHome();
    var want = this.followTarget(px, py);
    if (!want) return;
    if (!this.moving && Math.hypot(want.x - this.x, want.y - this.y) < 120) return; // dead zone: no jittery chasing
    this.setTarget(want.x, want.y, false);
  };
  PABuddy.prototype.onPointerOver = function (e) {
    if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
    var card = e.target && e.target.closest ? e.target.closest('product-card') : null;
    if (card && card !== this.hoverCard) this.enterCard(card, 'hover');
  };
  PABuddy.prototype.onPointerOut = function (e) {
    if ((e.pointerType !== 'mouse' && e.pointerType !== 'pen') || !this.hoverCard || this.hoverVia !== 'hover') return;
    var to = e.relatedTarget;
    if (to && this.hoverCard.contains(to)) return;
    this.leaveCard(false);
  };
  PABuddy.prototype.onFocusIn = function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (this.mobile && t.matches('input, textarea, select, [contenteditable="true"]')) this.setSuppressed('typing', true);
    var card = t.closest('product-card');
    if (card && card !== this.hoverCard && t.matches(':focus-visible')) this.enterCard(card, 'focus');
  };
  PABuddy.prototype.onFocusOut = function (e) {
    this.setSuppressed('typing', false);
    if (this.hoverCard && this.hoverVia === 'focus') {
      var to = e.relatedTarget;
      if (!(to && this.hoverCard.contains(to))) this.leaveCard(false);
    }
  };
  PABuddy.prototype.isBlocked = function () {
    for (var r of this.suppress) if (r !== 'crowded') return true;
    return false;
  };
  PABuddy.prototype.enterCard = function (card, via) {
    if (!this.reactsToProducts || this.isBlocked()) return;
    if (this.canTravel) this.setSuppressed('crowded', false);
    if (this.hoverCard && this.hoverCard !== card) this.leaveCard(true);
    var self = this;
    var id = card.dataset.productId || card.id || '';
    this.hoverCard = card; this.hoverId = id; this.hoverVia = via;
    this.clearNamed('home'); this.clearNamed('leaveHome');
    this.setNamed('dwell', 220, function () {
      if (self.hoverCard !== card) return;
      var t = now();
      var switched = self.lastCardId && self.lastCardId !== id && t - self.lastLeave < 1800;
      var sameAgain = self.lastCardId === id && t - self.lastLeave < 1500;
      self.state.lastEvent = switched ? 'switch' : 'hover';
      var soldOut = self.isSoldOut(card);
      if (switched) self.react('pout', 900, function () { self.react('curious', 1000, null, soldOut ? 'sad' : null); });
      else if (soldOut && !sameAgain) { self.react('curious', 1800, null, 'sad'); self.say(SOLD_OUT_LINE, 2200); }
      else if (!sameAgain) self.react('curious', 1000);
      if (self.canTravel) { var p = self.bestSpotNear(card); self.setTarget(p.x, p.y, false, p.peek); }
      else self.faceTowards(card);
      if (!soldOut) self.setNamed('encourage', 2600, function () { self.encourage(card, id); });
    });
    this.render();
  };
  PABuddy.prototype.isSoldOut = function (card) {
    if (/sold\s*out/i.test(card.textContent || '')) return true;
    var btn = card.querySelector('add-to-cart-component button, .quick-add__button');
    return !!(btn && btn.disabled);
  };
  PABuddy.prototype.leaveCard = function (switching) {
    if (!this.hoverCard) return;
    var self = this;
    this.lastCardId = this.hoverId; this.lastLeave = now();
    this.hoverCard = null; this.hoverId = null; this.hoverVia = null;
    this.clearNamed('dwell'); this.clearNamed('encourage');
    this.hideBubble();
    if (!switching) {
      if (this.canFollow) this.scheduleReturnHome();
      else if (this.canTravel) this.setNamed('leaveHome', 1400, function () { if (!self.hoverCard) self.goHome(); });
    }
    this.render();
  };
  PABuddy.prototype.encourage = function (card, id) {
    if (this.hoverCard !== card || this.pointed.has(id)) return;
    if (!this.cfg.bubbles || now() - this.lastBubble < 20000 || this.bubbleCount >= 4) return;
    this.pointed.add(id);
    this.faceTowards(card);
    this.react('point', 2400, null, 'wink');
    this.say(HOVER_LINES[Math.floor(Math.random() * HOVER_LINES.length)], 2400);
  };
  PABuddy.prototype.onPointerDown = function (e) {
    if (e.pointerType === 'mouse' || !this.reactsToProducts || this.isSuppressed()) return;
    var t = e.target;
    var card = t && t.closest ? t.closest('product-card') : null;
    if (!card) return;
    var id = card.dataset.productId || card.id || '';
    if (this.tappedId === id) return;
    this.tappedId = id;
    this.faceTowards(card);
    this.react('curious', 1200);
  };
  PABuddy.prototype.onClick = function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.closest(CHECKOUT_SELECTOR)) {
      this.setSuppressed('checkout', true);
      this.state.lastEvent = 'checkout';
      return;
    }
    var link = t.closest('product-card a[href]');
    if (link && !t.closest(CARD_CONTROL_SELECTOR)) {
      var card = link.closest('product-card');
      var id = card ? (card.dataset.productId || '') : '';
      store('set', SELECT_KEY, JSON.stringify({ id: id, t: Date.now() }));
      this.state.lastEvent = 'select';
      if (this.reactsToProducts && !this.isSuppressed()) this.react('excited', 700);
    }
  };
  PABuddy.prototype.checkArrival = function () {
    if (this.cfg.pageType !== 'product' || !this.reactsToProducts) return;
    var raw = store('get', SELECT_KEY);
    if (!raw) return;
    store('del', SELECT_KEY);
    var sel = null;
    try { sel = JSON.parse(raw); } catch (e) { return; }
    if (!sel || Date.now() - sel.t > 60000) return;
    if (this.cfg.productId && sel.id && String(sel.id) !== String(this.cfg.productId)) return;
    var self = this;
    this.state.lastEvent = 'arrival';
    this.setNamed('arrive', 700, function () { self.react('hold', 1800, null, 'happy'); self.say("Let's have a look!", 2200, true); });
  };

  /* ---------- cart ---------- */
  PABuddy.prototype.refreshCart = function (resource) {
    var self = this;
    var p;
    if (resource && Array.isArray(resource.items)) p = Promise.resolve(resource);
    else {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      p = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return p.then(function (cart) {
      if (cart && Array.isArray(cart.items) && !self.destroyed) {
        self.cart = { count: cart.item_count || 0, lines: cart.items.length };
        self.render();
      }
      return cart;
    });
  };
  PABuddy.prototype.onCartUpdate = function (e) {
    var d = (e && e.detail) || {};
    var data = d.data || {};
    var self = this;
    if (data.didError) {
      this.state.ignoredErrors++; this.state.lastEvent = 'add-failed';
      log('add failed – no celebration');
      this.refreshCart();
      return;
    }
    var isAdd = data.source === 'product-form-component';
    var seq = ++this.cartSeq;
    var before = this.cart.count;
    // For adds, always re-read the cart so the celebration is based on real contents.
    this.refreshCart(isAdd ? null : d.resource).then(function (cart) {
      if (seq !== self.cartSeq || self.destroyed) return;
      // Cart changes re-render parts of the page; re-check that her spot is still clear.
      self.setNamed('rehome', 450, function () { self._avoid = null; self.refreshHome(); });
      if (!isAdd) {
        if (!cart || !Array.isArray(cart.items)) return;
        var after = cart.item_count || 0;
        if (after !== before) { self.state.lastEvent = after > before ? 'qty-up' : 'qty-down'; self.cartChanged(after > before ? 'up' : 'down', after); }
        return;
      }
      var ok = cart && Array.isArray(cart.items) &&
        (!data.productId || cart.items.some(function (i) { return String(i.product_id) === String(data.productId); }));
      if (!ok) { self.state.lastEvent = 'add-unconfirmed'; log('add not confirmed in cart'); return; }
      self.state.lastEvent = 'add-confirmed';
      self.celebrate();
    });
  };
  PABuddy.prototype.cartChanged = function (dir, count) {
    if (this.suppress.has('dialog')) { this.pendingCartChange = { dir: dir, count: count, t: now() }; return; }
    this.playCartChange(dir, count);
  };
  PABuddy.prototype.playCartChange = function (dir, count) {
    if (this.suppress.has('dialog')) { this.pendingCartChange = { dir: dir, count: count, t: now() }; return; }
    if (this.isSuppressed() || !this.reactsToProducts) return;
    if (dir === 'up') this.react('thumbs', 1400, null, 'happy');
    else {
      this.react('curious', 1400, null, 'sad');
      if (count === 0) this.say(EMPTY_LINE, 2400);
    }
  };
  PABuddy.prototype.celebrate = function () {
    if (this.suppress.has('checkout')) return;
    if (this.suppress.has('dialog')) { this.pendingCelebrate = now(); log('celebration queued until dialog closes'); return; }
    this.playCelebration();
  };
  PABuddy.prototype.playCelebration = function () {
    if (this.suppress.has('dialog')) { this.pendingCelebrate = now(); return; } // another dialog opened: wait again
    if (this.isSuppressed()) return;
    var self = this;
    this.state.celebrations++;
    this.lastCelebrateAt = now();
    var celebrate = function () { self.react('celebrate', 1700, null, 'happy'); };
    if (this.cfg.assets.cart) this.react('cart', 600, celebrate); else celebrate();
    if (!this.reduced) {
      this.root.classList.remove('is-jump');
      void this.root.offsetWidth;
      this.root.classList.add('is-jump');
      this.setNamed('jump', 1150, function () { self.root.classList.remove('is-jump'); });
    }
    this.say(ADDED_LINE, 2200, true);
  };

  /* ---------- environment changes ---------- */
  PABuddy.prototype.onScroll = function () {
    if (this.scrollQueued) return;
    this.scrollQueued = true;
    var self = this;
    requestAnimationFrame(function () {
      self.scrollQueued = false;
      if (self.destroyed) return;
      if (self.hoverCard && self.canTravel) {
        var p = self.bestSpotNear(self.hoverCard);
        self.setTarget(p.x, p.y, false, p.peek);
      } else if (self.atHome) {
        self.refreshHome();
      }
    });
  };
  PABuddy.prototype.onResize = function () {
    this.applyEnv();
    if (this.atHome || !this.canTravel) this.goHome(true);
    else { var p = this.clampPos(this.tx, this.ty); this.setTarget(p.x, p.y, false); }
    this.shownKey = null;
    this.render();
  };

  PABuddy.prototype.destroy = function () {
    this.destroyed = true;
    this.ac.abort();
    if (this.mo) this.mo.disconnect();
    cancelAnimationFrame(this.raf);
    this.named.forEach(function (id) { clearTimeout(id); });
    this.named.clear();
    if (this.root.parentNode) this.root.parentNode.removeChild(this.root);
  };

  var Controller = {
    instances: new Map(),
    boot: function () {
      var els = document.querySelectorAll('[data-pa-buddy]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.__paBuddy) continue;
        Controller.instances.forEach(function (inst) { inst.destroy(); });
        Controller.instances.clear();
        try {
          var inst = new PABuddy(el);
          el.__paBuddy = inst;
          Controller.instances.set(inst.sectionId, inst);
        } catch (err) {
          console.warn('[PA Buddy] init failed', err);
        }
      }
    },
    get: function () { return Controller.instances.values().next().value || null; }
  };
  window.PABuddyController = Controller;

  document.addEventListener('shopify:section:load', function () { Controller.boot(); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    var inst = Controller.instances.get(id);
    if (inst) { inst.destroy(); Controller.instances.delete(id); }
  });

  function start() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(Controller.boot, { timeout: 2000 });
    else setTimeout(Controller.boot, 200);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
